<template>
    <svg
        width="125"
        height="127"
        viewBox="0 0 125 127"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <ellipse
            cx="62.5"
            cy="63.5"
            rx="62"
            ry="63.5"
            fill="#F1F1F1"
        />
        <path
            d="M64.5567 57.792L64.7164 57.8065L78.1632 59.5781C86.6001 60.6963 93.0911 67.1002 94.0931 75.2902L96.6924 95.3587C96.8086
            96.23 96.1261 96.9996 95.2548 96.9996H31.3609C30.4751 96.9996 29.8071 96.2155 29.9233 95.3442L32.6678 75.479C33.4956 67.318
            40.1028 60.856 48.5977 59.7233L62.0445 57.9517L62.2333 57.9372H63.8887L63.9468 57.9082C64.1356 57.8356 64.3389 57.792 64.5567
            57.792Z"
            fill="white"
        />
        <path
            d="M63.7122 56.7852L63.876 56.8001L77.6681 58.6172C86.3217 59.764 92.9795 66.3324 94.0072 74.7328L96.6732 95.3167C96.7924
            96.2104 96.0924 96.9998 95.1987 96.9998H29.6638C28.7552 96.9998 28.0701 96.1955 28.1893 95.3018L31.0043 74.9264C31.8533
            66.5558 38.6302 59.9279 47.3433 58.7661L61.1354 56.949L61.3291 56.9341H63.027L63.0866 56.9043C63.2802 56.8298 63.4888
            56.7852 63.7122 56.7852ZM41.5792 88.0632H32.1958L31.3766 94.0209H41.5792V88.0632ZM73.736 61.1045L63.7271 75.5073C63.176
            76.2967 62.044 76.3563 61.4035 75.6711L61.2844 75.5222L51.2307 61.2534L47.7306 61.7152C40.6409 62.6535 35.13 67.8218
            34.0725 74.4498L34.0129 74.8668L33.9683 75.2839L32.6129 85.0843H41.5792V76.1477C41.5792 75.3286 42.2495 74.6583 43.0687
            74.6583C43.8283 74.6583 44.4687 75.2392 44.5432 75.969L44.5581 76.1477V94.0209H78.815V76.1477C78.815 75.3286 79.4852
            74.6583 80.3044 74.6583C81.064 74.6583 81.7045 75.2392 81.7789 75.969L81.7938 76.1477V85.0843H92.2198H92.3539L91.0581
            75.1051C90.2389 68.3431 85.0557 62.9812 78.1745 61.7003L77.7277 61.6258L77.2958 61.5662L73.736 61.1045ZM92.3986 88.0483L92.2198
            88.0632H81.7938V94.0209H93.5008L92.7262 87.9738C92.622 88.0185 92.5028 88.0334 92.3986 88.0483ZM64.159 59.8385L64.0249
            59.8832C63.9207 59.913 63.8015 59.9279 63.6824 59.9279H61.4333L54.5671 60.8364L62.4908 72.0816L70.4146 60.6875L64.159 59.8385Z"
            fill="#747474"
        />
        <rect
            x="19.5"
            y="94.3975"
            width="85.8795"
            height="2.60241"
            rx="1.30121"
            fill="#747474"
        />
        <path
            d="M64.2954 25.8672C70.5513 25.8672 75.7314 30.8838 75.7314 37.0776V51.2727C75.5616 57.3684 70.4805 62.3009 64.2954
            62.3009H60.29C54.02 62.3009 48.8398 57.2843 48.8398 51.0905V37.0776C48.8398 30.9259 53.9634 25.8672 60.2758 25.8672H64.2954Z"
            fill="white"
        />
        <path
            d="M64.3896 25C70.9729 25 76.4242 30.3322 76.4242 36.9154V52.0034C76.2454 58.4824 70.8984 63.7252 64.3896 63.7252H60.1745C53.5763
            63.7252 48.125 58.393 48.125 51.8097V36.9154C48.125 30.3768 53.5167 25 60.1596 25H64.3896ZM63.7193 34.7111L63.4959 34.9196C60.5617
            37.6453 56.4658 38.9411 51.1039 38.1963V51.8097C51.1039 56.7397 55.1998 60.7463 60.1596 60.7463H64.3747C69.2749 60.7463 73.3113
            56.7993 73.4304 51.9587V38.0176L73.3708 38.0325C68.3068 39.1645 65.1492 37.675 63.7193 34.7111ZM67.4131 28.5002L67.4578
            28.3065C67.2344 29.2896 66.7578 30.5854 65.9237 31.9556C65.9386 32.0152 65.9684 32.0748 65.9833 32.1493C66.5641 34.8749
            68.4557 36.2154 73.1027 35.0536L73.2517 35.0239C72.5665 31.9854 70.3175 29.513 67.4131 28.5002ZM64.3896 27.9789H60.1745C55.7658
            27.9789 52.0869 31.1216 51.2826 35.2175C51.2975 35.2175 51.3124 35.2175 51.3273 35.2175C56.6594 36.0069 60.249 34.5026 62.5874
            31.5237C63.2576 30.6598 63.7789 29.7364 64.1662 28.8129L64.2555 28.5895L64.4045 28.1874C64.4194 28.1278 64.4491 28.0682 64.464
            28.0235L64.4491 27.9789H64.3896Z"
            fill="#747474"
        />
        <circle
            cx="57.0623"
            cy="43.6179"
            r="2.23414"
            fill="#747474"
        />
        <circle
            cx="67.4881"
            cy="43.6179"
            r="2.23414"
            fill="#747474"
        />
        <path
            d="M67.7884 55.7449C66.5521 54.2555 64.4074 53.3022 62.1583 53.3022C59.8795 53.3022 57.8837 54.1512 56.6772 55.6109C56.1559 56.2364
            55.2176 56.3258 54.5771 55.8045C53.9516 55.2832 53.8622 54.3448 54.3835 53.7044C56.1857 51.5447 59.0156 50.3234 62.1583 50.3234C65.2712
            50.3234 68.265 51.649 70.0821 53.8384C70.6034 54.464 70.514 55.4172 69.8885 55.9385C69.248 56.4598 68.3097 56.3705 67.7884 55.7449Z"
            fill="#8EC63E"
        />
    </svg>
</template>

<script>
export default {
  name: 'IconSadPerson',
};
</script>
